import React from "react";
import "./style.css";

interface NumberInputProps {
  minutes: number; // Current minutes value to display
  incrementMinutes: () => void; // Function to handle incrementing minutes
  decrementMinutes: () => void; // Function to handle decrementing minutes
  disableIncrement?: boolean;
  disableDecrement?: boolean;
}

const NumberInput: React.FC<NumberInputProps> = ({
  minutes,
  incrementMinutes,
  decrementMinutes,
  disableIncrement = false,
  disableDecrement = false,
}) => {
  
  return (
    <div className="number-input-container">
      <button
        type="button"
        onClick={decrementMinutes}
        disabled={disableDecrement}
        className="number-input-button"
      >
        -
      </button>
      <input
        type="number"
        value={minutes}
        readOnly
        className="number-input-field"
      />
      <button
        type="button"
        onClick={incrementMinutes}
        disabled={disableIncrement}
        className="number-input-button"
      >
        +
      </button>
    </div>
  );
};

export default NumberInput;
